<template>
  <div class="user-detail-address">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailAddressInfo.addresses" border style="width: 100%">
        <el-table-column prop="userName" :label="$t('userDetailAddress.receiver')" align="center">
        </el-table-column>
        <el-table-column prop="tel" :label="$t('userDetailAddress.receiverTel')" align="center">
        </el-table-column>
        <el-table-column prop="address" :label="$t('userDetailAddress.receiverAddress')" align="center">
        </el-table-column>
        <el-table-column prop="isDefault" :label="$t('userDetailAddress.isDefault')" align="center">
          <template slot-scope="scope">
            {{ scope.row.isDefault === 'T' ? $t('userDetailAddress.yes') : $t('userDetailAddress.no') }}
          </template>
        </el-table-column>
        <el-table-column prop="postalCode" :label="$t('userDetailAddress.postalCode')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailAddress.createTime')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getUserAddressList } from '@/api/user/userDetailAddressApi'

export default {
  name: 'UserDetailAddress',
  data() {
    return {
      userDetailAddressInfo: {
        addresses: [],
        userId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailAddressInfo.userId = data.userId
      this.loadAddressData()
    },
    loadAddressData() {
      const params = {
        userId: this.userDetailAddressInfo.userId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getUserAddressList(params).then(res => {
        this.userDetailAddressInfo.addresses = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadAddressData()
    }
  }
}
</script>

<style scoped>
.user-detail-address {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>